import * as angular from 'angular';
import * as _ from 'lodash';
import nvSupportsModule from '../_module';

export class SupportsRosterExporterService {
  createSupportsRosterCsv(supportsRoster) {
    const header = [
      'Student ID',
      'Last Name',
      'First Name',
      'Start Date',
      'Review Date',
      'Status',
      'Present',
      'Absent',
      'Late',
      '# of Logs',
    ];

    let csvRows = header + '\n';

    _.each(supportsRoster, (row: any) => {
      const name = row.lastFirst.split(', ');
      csvRows +=
        [
          row.studentIdTrimmed,
          name[0],
          name[1],
          row.startsOnString,
          row.reviewOnString,
          row.humanReadableStatus,
          row.attendanceObj ? row.attendanceObj.percentPres : '',
          row.attendanceObj ? row.attendanceObj.percentAbs : '',
          row.attendanceObj ? row.attendanceObj.percentLate : '',
          row.attendanceObj ? row.attendanceObj.logs : '',
        ] + '\n';
    });
    return csvRows;
  }
}

angular.module(nvSupportsModule).service('SupportsRosterExporterService', SupportsRosterExporterService);
